/* tslint:disable */

declare var Object: any;
export interface LibraryInterface {
  "name"?: string;
  "displayName"?: string;
  "description"?: string;
  "image": string;
  "video"?: string;
  "author"?: string;
  "icon"?: string;
  "logo"?: string;
  "active"?: boolean;
  "data"?: any;
  "createdAt"?: Date;
  "createdBy"?: number;
  "updatedAt"?: Date;
  "updatedBy"?: number;
  "id"?: number;
}

export class Library implements LibraryInterface {
  "name": string;
  "displayName": string;
  "description": string;
  "image": string;
  "video": string;
  "author": string;
  "icon": string;
  "logo": string;
  "active": boolean;
  "data": any;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  constructor(data?: LibraryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Library`.
   */
  public static getModelName() {
    return "Library";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Library for dynamic purposes.
  **/
  public static factory(data: LibraryInterface): Library{
    return new Library(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Library',
      plural: 'Libraries',
      path: 'Libraries',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "displayName": {
          name: 'displayName',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "image": {
          name: 'image',
          type: 'string'
        },
        "video": {
          name: 'video',
          type: 'string'
        },
        "author": {
          name: 'author',
          type: 'string'
        },
        "icon": {
          name: 'icon',
          type: 'string'
        },
        "logo": {
          name: 'logo',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean',
          default: true
        },
        "data": {
          name: 'data',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
